import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  useTheme,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { Document, PDFViewer, Page, View } from '@react-pdf/renderer';
import * as React from 'react';
import * as Redux from 'react-redux';
import Modal from '../../../../widgets/modals/Modal';
import { stylesDocPdf } from '../../../pdfs';
import HeaderPdf from '../../../pdfs/HeaderPdf';
import TablaReportesAsistencias from './TablaReporteAsistencias';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styles = {
  pdfViewer: {
    width: '100%',
    height: '80vh',
    zIndex: 50,
  },
  section: {
    flex: 1,
    ...stylesDocPdf.section,
    margin: '20pt',
  },
};

export const columnsReportesAsistencias = [
  {
    id: 'dni',
    name: 'Cédula',
  },
  {
    id: 'fullname',
    name: 'Nombres y apellidos',
  },
  {
    id: 'nivel',
    name: 'Nivel',
  },
  {
    id: 'seccion',
    name: 'Sección',
  },
  {
    id: 'docente',
    name: 'Docente',
  },
  {
    id: 'materia',
    name: 'Materia',
  },
  {
    id: 'horario',
    name: 'Horario',
  },
];

function getStyles(column, columnSelect, theme) {
  return {
    fontWeight:
      columnSelect.indexOf(column) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

// Create Document Component
const ReportesAsistencias = () => {
  const theme = useTheme();
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const asistenciasStore = Redux.useSelector((state) => state.asistencias);

  const [loadingDoc, setLoadingDoc] = React.useState(true);
  const [columnSelect, setColumnSelects] = React.useState([
    'dni',
    'fullname',
    'nivel',
    'seccion',
    'docente',
    'materia',
    'horario',
  ]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setColumnSelects(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const select = (
    <FormControl fullWidth>
      <InputLabel id="reportes-asistencias-label">
        Columnas a mostrar
      </InputLabel>
      <Select
        labelId="reportes-asistencias-label"
        id="reportes-asistencias"
        multiple
        value={columnSelect}
        onChange={handleChange}
        input={
          <OutlinedInput id="select-multiple-chip" label="Columnas a mostrar" />
        }
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => {
              const item = columnsReportesAsistencias.find(
                (column) => column.id === value,
              );
              return <Chip key={item.id} label={item.name} />;
            })}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {columnsReportesAsistencias.map((column) => (
          <MenuItem
            key={column.id}
            value={column.id}
            style={getStyles(column.id, columnSelect, theme)}
          >
            {column.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {select}
      </Grid>
      <Grid item md={12}>
        <PDFViewer style={styles.pdfViewer} showToolbar={true}>
          <Document
            title="Reporte de acceso"
            onRender={() => setLoadingDoc(false)}
          >
            <Page size="A4" style={stylesDocPdf.page} orientation="landscape">
              <View style={styles.section}>
                <HeaderPdf entidad={entidadesStore.activo} />
                <TablaReportesAsistencias
                  data={asistenciasStore.all}
                  columnSelect={columnSelect}
                />
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </Grid>
      <Modal open={loadingDoc}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="h6" sx={{ textAlign: 'center' }}>
            Generando reporte...
          </Typography>
          <LinearProgress />
          {/* <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              Procesando la cantidad {asistenciasStore.all.length} asistencias
            </Typography> */}
          <Typography sx={{ textAlign: 'center' }}>
            Este proceso puede que tarde entre 1 a 3 minutos para completa, por
            favor espere.
          </Typography>
        </Box>
      </Modal>
    </Grid>
  );
};

export default ReportesAsistencias;
